import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var RotateCw = createReactComponent("RotateCw", ["svg", defaultAttributes, [["path", {
  d: "M21 2v6h-6",
  key: "1vq7dv"
}], ["path", {
  d: "M21 13a9 9 0 11-3-7.7L21 8",
  key: "v7e9xy"
}]]]);
export default RotateCw;